export const defaultValue = {
    id: '',
    title: '',
    description: '',
    status: 'open',
    priority: 'medium',
    assignedTo: '',
    customerId: '',
    createdAt: null,
    updatedAt: null,
};
